import { alpha } from '@mui/material';
import { getBookingStatusConfig } from './constants/bookingStatus';

export const getBookingStatusChipSx = (status: string) => {
  const key = status?.toLowerCase();
  if (key === 'enquiry') {
    return {
      bgcolor: '#F3E5F5',
      color: '#7B1FA2',
      borderColor: alpha('#7B1FA2', 0.35),
    };
  }
  const config = getBookingStatusConfig(status);
  return {
    bgcolor: config.bgColor,
    color: config.color,
    borderColor: alpha(config.color, 0.35),
  };
};
